'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var WalletPaymentMethod = module.exports = SoaModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethod');

_.extend(WalletPaymentMethod.prototype, {
    relations : SoaModel.createRelations([{
        key : 'paymentMethod',
        relatedModel : PaymentMethod,
        type : Backbone.One
    }])
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/WalletPaymentMethod.js
// module id = 193
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55